module.exports = "<template>\r\n    <slot></slot>\r\n</template>";